export default __webpack_public_path__ + "static/media/icon-silver.8f93da19.svg";